import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { reactive } from "vue";

const title = "Impala";
const routes: Array<RouteRecordRaw> = [
  {
    name: "rtm",
    path: "/rtm",
    component: () => import("@/components/projects/preview/RTM.vue"),
  },
  {
    name: "SurveyPage",
    path: "/survey-page/:projectId",
    component: () => import("../views/projects/SurveyPage.vue"),
  },
  {
    path: "/",
    name: "DefaultLayout",
    component: () => import("../layouts/default.vue"),
    children: [
      {
        path: "/sign-in",
        name: "SignIn",
        component: () => import("../views/auth/SignIn.vue"),
        meta: {
          requiresAuth: false,
          title: "Sign In | " + title,
        },
      },
      {
        path: "/sign-up",
        name: "SignUp",
        component: () => import("../views/auth/SignUp.vue"),
        meta: {
          requiresAuth: false,
          title: "Sign Up | " + title,
        },
      },
      {
        path: "/forgot-password",
        name: "ForgotPassword",
        component: () => import("../views/reset-password/ForgotPassword.vue"),
        meta: {
          requiresAuth: false,
          title: "Forgot Password | " + title,
        },
      },
      {
        path: "/check-mail",
        name: "CheckMail",
        component: () => import("../views/reset-password/CheckMail.vue"),
        meta: {
          requiresAuth: false,
          title: "Check mail | " + title,
        },
      },
      {
        path: "/loading",
        name: "Loading",
        component: () => import("../components/layouts/LoadingPage.vue"),
        meta: {
          title: "Loading | " + title,
        },
      },
      {
        name: "HRProjectDetail",
        component: () => import("../views/hr-projects/HRProject.vue"),
        path: "/hr-projects/:projectId",
      },
      {
        path: "/:pathMatch(.*)*",
        name: "ErrorPage",
        component: () => import("../views/ErrorPage.vue"),
        meta: {
          title: "Error | " + title,
        },
      },
      {
        path: "/",
        component: () => import("../views/AuthenticatedPageWrapper.vue"),
        meta: {
          requiresAuth: true,
          title: title,
        },
        children: [
          {
            name: "Secured",
            path: "/",
            redirect: (ptf) => {
              console.log("ptf", ptf);
              return { name: "HR Projects" };
            },
            meta: {
              isMedical: false,
            },
          },

          {
            name: "Projects",
            path: "/projects",
            component: () => import("../views/projects/Index.vue"),
            meta: {
              title: "Projects | " + title,

              isMedical: false,
            },
          },
          {
            path: "/flows",
            children: [
              {
                path: "",
                name: "Flows",
                component: () => import("../views/flows/Index.vue"),
              },
              {
                path: "create",
                name: "FlowCreate",
                // component: () => import("../views/flows/CreateFlow.vue"),
                component: () => import("../views/flows/Creation.vue"),
              },
            ],
          },
          {
            path: "/question-groups",
            children: [
              {
                path: "",
                name: "Question Groups",
                component: () => import("../views/question-groups/Index.vue"),
              },
              {
                path: "create",
                name: "QuestionGroupsCreate",
                component: () =>
                  import("../views/question-groups/CreateQuestionGroup.vue"),
              },
            ],
          },

          {
            path: "/hr-projects",
            children: [
              {
                name: "HR Projects",
                component: () => import("../views/hr-projects/HRProjects.vue"),
                path: "",
              },
              {
                name: "HRSector",
                path: ":hrProjectId/:flowId/sectors",
                component: () => import("../views/hr-projects/HRSector.vue"),
              },

              {
                name: "HRParticipantsAdd",
                path: ":hrProjectId/:sectorId/add-participants",
                component: () =>
                  import("../views/hr-participant/AddParticipants.vue"),
              },
            ],
          },

          {
            name: "Medical Tests",
            path: "/medical-tests",
            component: () => import("../views/medical-tests/Index.vue"),
            meta: {
              title: "Medical Tests | " + title,
              isMedical: true,
            },
          },

          {
            path: "/questionnaire",
            children: [
              {
                name: "Questionnaire",
                path: "",
                component: () =>
                  import("../views/questionaire/Questionnaire.vue"),
                meta: {
                  title: "Questions | " + title,
                },
              },
              {
                name: "QuestionnaireCreate",
                path: "create",
                component: () =>
                  import("../views/questionaire/QuestionnaireCreate.vue"),
                meta: { title: "Create Questionnaire | " + title },
              },
            ],
          },

          /* {
            name: "CreateProject",
            path: "/projects/create",
            component: () => import("../views/projects/Create.vue"),
            meta: { title: "Create Project | " + title },
          },
          {
            name: "EditProject",
            path: "/projects/edit",
            component: () => import("../views/projects/Edit.vue"),
            meta: { title: "Edit Project | " + title },
          }, */
          {
            name: "Project",
            path: "/projects/:projectId/:step",
            component: () => import("../views/projects/Stepper.vue"),
            meta: { title: "Project | " + title },
          },
          /* {
            name: "CreateStimuli",
            path: "/create-stimuli",
            component: () => import("../views/projects/stimuli/Create.vue"),
            meta: { title: "Create Stimuli | " + title },
          }, */
          {
            name: "EditStimuli",
            path: "/edit-stimuli/:stimulId",
            component: () => import("../views/projects/stimuli/Create.vue"),
            meta: { title: "Create Stimuli | " + title },
          },
          {
            name: "Credits",
            path: "/credits",
            component: () => import("../views/Credits.vue"),
            meta: { title: "Edit  | " + title },
          },
          {
            path: "/blog",
            name: "Blog",
            component: () => import("../views/blog/Index.vue"),
            meta: {
              requiresAuth: false,
              title: "Blogs | " + title,
            },
          },
          {
            path: "/blog/:blogId",
            name: "BlogShow",
            component: () => import("../views/blog/Show.vue"),
            meta: {
              requiresAuth: false,
              title: "Blog | " + title,
            },
          },
        ],
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Create a reactive object to store the route history
const routeHistory = reactive({
  previous: {},
  current: {},
});

// Set up a global beforeEach guard to track route changes
router.beforeEach((to, from, next) => {
  if (routeHistory.current) routeHistory.previous = routeHistory.current;
  if (to) routeHistory.current = to;
  next();
});

export { router, routeHistory };
